import { useEffect, useState } from "react";
import appConfig from "../../../config/app.config.json";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { useNavigate } from "react-router-dom";
import {
  cancelLine,
  leavingReach,
  terminateLine,
} from "../../../features/account/accountSlice";
import { getCache, isTemplateExisits } from "../../../utils/commonFunctions";
import { getCancelLineContent } from "../../../features/strapi/accountSlice";
import { CustomerStatus as CS } from "../../../enums";

const CancelLineTemplate = isTemplateExisits(appConfig.MyAccount.CancelLine)
  ? require(`./${appConfig.MyAccount.CancelLine.template}_CancelLine`).default
  : null;

const CancelLine = (props: any) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { cancelLineData } = useAppSelector((state: any) => state.account);
  const { cancelLineContent } = useAppSelector(
    (state: any) => state.strapi.account
  );
  const { currentUser } = props;
  const { configKeys } = useAppSelector((state: any) => state?.activation);
  const [cacheContent, setCacheContent] = useState<any>(null);
  const [cancelReason, setCancelReason] = useState(null);
  let customerDetails: any = localStorage.getItem("customerDetail");
  customerDetails = JSON.parse(customerDetails);
 

  useEffect(() => {
    window.scroll(0, 0);
    getCache("CancelLine", getCancelLineContent, setCacheContent, dispatch);
  }, []);

  const handleCancelLine = () => {
    let currentUserID: any = currentUser.id;
    let payload;
    if (currentUser.status === CS.ACTIVE) {
      payload = {
        reason: cancelReason,
        customers: {
          [currentUserID]: {
            type: "DISCONNECT",
          },
        },
      };
      dispatch(
        leavingReach({
          customerId: customerDetails.id,
          payload: payload,
        })
      );
    } else if (currentUser.billingStatus === 0) {
      payload = {
        primaryReason: cancelReason,
      };
      dispatch(
        cancelLine({
          customerId: currentUser.id,
          payload: payload,
        })
      );
    } else if (currentUser.billingStatus === 1) {
      payload = {
        primaryReason: cancelReason,
      };
      dispatch(
        terminateLine({
          customerId: currentUser.id,
          payload: payload,
        })
      );
    }
  };

  return !cancelLineContent || !cacheContent ? (
    <CancelLineTemplate
      {...props}
      handleCancelLine={handleCancelLine}
      setCancelReason={setCancelReason}
      cancelReason={cancelReason}
      Content={cacheContent ? cacheContent : cancelLineContent}
    />
  ) : null;
};
export default CancelLine;
